import React, { useState, useEffect } from "react";
import "./NavBar.css";
import { NavLink, Link, useLocation } from "react-router-dom";
import NavMenuItem from "./NavMenuItem.js";
import NavCompactItem from "./NavCompactItem.js";

const navitems = [
  {
    title: "Committee",
    items: [
      {
        title: "Organisation Committee",
        url: "/organisationcommittee",
      },
      {
        title: "Technical Programme Committee",
        url: "/technicalcommittee",
      },
    ],
  },
  {
    title: "Calls",
    items: [
      {
        title: "Call for Research Papers",
        url: "/researchcalls",
      },
      {
        title: "Call for Industry Papers",
        url: "/industrycalls",
      },
      { title: "Call for Posters/Demos", url: "/postercalls" },
      {
        title: "Call for Workshop Papers",
        url: "/workpapercalls",
      },
      {
        title: "Call for Workshop Proposals",
        url: "/workproposalcalls",
      },
      {
        title: "Call for PhD Forum",
        url: "/phdforumcalls",
      },
      {
        title: "Call for Tutorials",
        url: "/tutorialcalls",
      },
    ],
  },
  {
    title: "Program",
    items: [
      { title: "Accepted Papers", url: "/acceptedpapers" },
      { title: "Schedule/Program", url: "/schedule" },
      { title: "Keynotes", url: "/keynotes" },
      { title: "Panel", url: "/inprogress" },
      {
        title: "Poster/Demo/PhD Forum",
        url: "/inprogress",
      },
      {
        title: "Tutorials",
        url: "/inprogress",
      },
    ],
  },
  {
    title: "Workshops",
    items: [{ title: "Workshops", url: "/workshops" }],
  },
  {
    title: "Attending",
    items: [
      { title: "Camera Ready", url: "/cameraready" },
      {
        title: "Registration",
        url: "/registration",
      },
      { title: "VISA", url: "/visa" },
      {
        title: "Venue",
        url: "/venue",
      },
      {
        title: "Directions",
        url: "/inprogress",
      },
      {
        title: "Accommodation",
        url: "/accommodation",
      },

      {
        title: "NSF Student Travel Grant",
        url: "/nsfgrant",
      },
    ],
  },
  {
    title: "Previous Years",
    items: [
      { title: "SmartComp 2024", url: "https://smartcomp.w.waseda.jp/" },
      {
        title: "SmartComp 2023",
        url: "https://smartcomp.isis.vanderbilt.edu/",
      },
      { title: "SmartComp 2022", url: "https://smartcomp.aalto.fi/" },
      { title: "SmartComp 2021", url: "https://smartcomp2021.weebly.com/" },
      {
        title: "SmartComp 2020",
        url: "https://smartcomp2020.weebly.com/home.html",
      },
    ],
  },
];

const singleNav = {
  title: "Committee",
  items: [
    {
      title: "Organisation Committee",
      url: "/organisationcommittee",
    },
    {
      title: "Technical Programme Committee",
      url: "/inprogress",
    },
  ],
};

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(true);
  }, [location]);

  return (
    <nav>
      <Link to="" className="title">
        IEEE SmartComp 2025
      </Link>
      <div
        className="menu"
        onClick={() => {
          setMenuOpen(!menuOpen);
        }}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul id="hide-menu">
        {navitems.map(function (data) {
          return (
            <li>
              <NavMenuItem props={data} />
            </li>
          );
        })}
      </ul>

      <div id="compact-menu">
        <div id={menuOpen ? "closed" : ""}>
          <NavCompactItem onClick={() => setMenuOpen(true)} />
        </div>
      </div>
    </nav>
  );
}
